import invoiceDevolutionRequests from '../../server/invoiceDevolution';
import { addLoading, removeLoading } from './loading';

export const setSphereMotivosList = sphereMotivos => ({
  type: 'SET_SPHERE_MOTIVOS_LIST',
  sphereMotivos,
});

export const setClientContactEmailsList = clientContactEmails => ({
  type: 'SET_CLIENT_CONTACT_EMAILS_LIST',
  clientContactEmails,
});

export const setInvoiceDevolutionList = invoiceDevolutionList => ({
  type: 'SET_INVOICE_DEVOLUTION_LIST',
  invoiceDevolutionList,
});

export const setInvoiceDevolutionDetails = invoiceDevolutionDetails => ({
  type: 'SET_INVOICE_DEVOLUTION_DETAILS',
  invoiceDevolutionDetails,
});

export const getSphereMotivosList = devolutionReasonType => async (dispatch) => {
  dispatch(addLoading());
  try {
    const sphereMotivos = await invoiceDevolutionRequests.getSphereMotivosList(devolutionReasonType);
    dispatch(setSphereMotivosList(sphereMotivos));
  } finally {
    dispatch(removeLoading());
  }
};

export const getClientContactEmailsList = clientId => async (dispatch) => {
  dispatch(addLoading());
  try {
    const clientContactEmails = await invoiceDevolutionRequests.getClientContactEmailsList(clientId);
    dispatch(setClientContactEmailsList(clientContactEmails));
  } finally {
    dispatch(removeLoading());
  }
};

export const getInvoiceDevolutionList = (data, filterBy) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const invoiceDevolutionList = await invoiceDevolutionRequests.getInvoiceDevolutionList(data, filterBy);
    dispatch(setInvoiceDevolutionList(invoiceDevolutionList));
  } finally {
    dispatch(removeLoading());
  }
};

export const getInvoiceDevolutionDetails = (nciNumber, devolutionNumber) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const invoiceDevolutionDetails = await invoiceDevolutionRequests.getInvoiceDevolutionDetails(
      nciNumber, devolutionNumber,
    );
    dispatch(setInvoiceDevolutionDetails(invoiceDevolutionDetails));
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadInvoiceDevolutionFile = (file, name, clientId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const devolutionFile = await invoiceDevolutionRequests.uploadInvoiceDevolutionFile(file, name, clientId);
    return devolutionFile;
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteInvoiceDevolutionFile = async file => invoiceDevolutionRequests.deleteInvoiceDevolutionFile(file);

export const sendInvoiceDevolutionSolicitation = solicitationData => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await invoiceDevolutionRequests.sendInvoiceDevolutionSolicitation(solicitationData);
  } finally {
    dispatch(removeLoading());
  }
};

export const createInvoiceDevolutionSolicitation = (solicitationData, sphereId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await invoiceDevolutionRequests.createInvoiceDevolutionSolicitation(solicitationData, sphereId);
  } finally {
    dispatch(removeLoading());
  }
};

export const cancelInvoiceDevolutionSolicitation = solicitationData => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await invoiceDevolutionRequests.cancelInvoiceDevolutionSolicitation(solicitationData);
  } finally {
    dispatch(removeLoading());
  }
};
